export const getFantasyMatches = (state) => state.fantasy?.matches;
export const getGroups = (state) => state.fantasy?.groups;
export const getFantasyTemplate = (state) => state.fantasy?.template;
export const getFantasyConfig = (state) => state.fantasy?.config;
export const getFantasyLoading = (state) => state.fantasy?.loading;
export const getFantasyError = (state) => state.fantasy?.error;
